import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Dialog, DialogTitle, DialogContent, DialogActions, Divider, Alert } from '@mui/material';
import { JsonView, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import { apiGet } from '../../../utils/fetch';
import { InitialUserDataInterface, GenericResponseInterface } from '../../../interfaces/interfaces';

const UsersAdminGetUserData: React.FC = () => {
    const [userId, setUserId] = useState('');
    const [user, setUser] = useState<InitialUserDataInterface | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [rawDialogOpen, setRawDialogOpen] = useState(false);

    const handleGetUserDataById = async () => {
        setError(null);
        setUser(null);
        if (!userId) return setError('Please enter a user ID');
        try {
            const result = await apiGet<GenericResponseInterface<InitialUserDataInterface>>(`/users/getUserData/userId/${userId}`);
            if (result.status && result.data) {
                setUser(result.data);
            } else {
                setError(result.message || 'Failed to fetch user');
            }
        } catch (err: any) {
            setError(err.message || 'Failed to fetch user');
        }
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <Button variant="contained" onClick={handleGetUserDataById}>Get User data by ID</Button>
                <TextField
                    label="User ID"
                    value={userId}
                    onChange={e => setUserId(e.target.value)}
                    size="small"
                />
            </Box>
            <Divider sx={{ mb: 2 }} />
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {user && (
                <Paper sx={{ p: 2, mb: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography variant="h6">User Data (Tree View)</Typography>
                        <Button variant="outlined" size="small" onClick={() => setRawDialogOpen(true)}>
                            View Raw JSON
                        </Button>
                    </Box>
                    <JsonView
                        data={user}
                        shouldExpandNode={(level) => level < 2}
                        style={defaultStyles}
                    />
                </Paper>
            )}
            <Dialog open={rawDialogOpen} onClose={() => setRawDialogOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Raw JSON</DialogTitle>
                <DialogContent>
                    <pre style={{ fontSize: 13, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                        {JSON.stringify(user, null, 2)}
                    </pre>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRawDialogOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default UsersAdminGetUserData;